module.exports = __webpack_public_path__ + "static/media/42.55b149c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/42.png
// module id = 614
// module chunks = 0